var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-today-item"},[_c('div',{staticClass:"today-title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"small-info"},[_vm._t("default")],2),_c('div',{ref:"chargeEchart",staticClass:"today-echart"}),_c('pi-home-modal',{ref:"homeModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }